import { motion } from "framer-motion";
import {
  Building2, GraduationCap, Stethoscope, Briefcase,
  Server, Cpu, HardHat, UtensilsCrossed,
} from "lucide-react";

const industries = [
  { name: "Real Estate", img: "https://images.pexels.com/photos/18893526/pexels-photo-18893526.jpeg", icon: Building2, color: "from-neon-orange/50 to-transparent" },
  { name: "Education", img: "https://images.unsplash.com/photo-1523580494863-6f3031224c94?w=1200&q=80", icon: GraduationCap, color: "from-neon-blue/50 to-transparent" },
  { name: "Healthcare", img: "https://images.unsplash.com/photo-1551076805-e1869033e561?w=1200&q=80", icon: Stethoscope, color: "from-neon-cyan/50 to-transparent" },
  { name: "Professional Services", img: "https://images.pexels.com/photos/6285113/pexels-photo-6285113.jpeg", icon: Briefcase, color: "from-neon-purple/50 to-transparent" },
  { name: "SaaS", img: "https://images.unsplash.com/photo-1526628953301-3e589a6a8b74?w=1200&q=80", icon: Server, color: "from-neon-magenta/50 to-transparent" },
  { name: "Technology", img: "https://images.unsplash.com/photo-1765275231879-b3c65c4e5981?w=1200&q=80", icon: Cpu, color: "from-neon-cyan/50 to-transparent" },
  { name: "Construction", img: "https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=1200&q=80", icon: HardHat, color: "from-neon-orange/50 to-transparent" },
  { name: "Hospitality", img: "https://images.unsplash.com/photo-1551882547-ff40c63fe5fa?w=1200&q=80", icon: UtensilsCrossed, color: "from-neon-magenta/50 to-transparent" },
];

export default function Industries() {
  return (
    <section id="industries" data-testid="industries-section" className="section relative">
      <div className="container-x">
        <div className="max-w-3xl mb-14">
          <p className="overline mb-4">Industries</p>
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight">
            Built for businesses ready to <span className="text-gradient-warm">scale</span>.
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {industries.map((ind, i) => {
            const Icon = ind.icon;
            return (
              <motion.div
                key={ind.name}
                data-testid={`industry-${ind.name.toLowerCase().replace(/\s+/g, '-')}`}
                initial={{ opacity: 0, y: 22 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-10%" }}
                transition={{ duration: 0.5, delay: (i % 4) * 0.06 }}
                className="group relative rounded-2xl overflow-hidden h-56 border border-white/[0.06] cursor-pointer"
              >
                <img
                  src={ind.img}
                  alt={ind.name}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover scale-105 group-hover:scale-110 transition-transform duration-700 opacity-70 group-hover:opacity-90"
                />
                <div className="absolute inset-0 bg-bg-0/70 group-hover:bg-bg-0/50 transition-colors duration-500" />
                <div className={`absolute inset-0 bg-gradient-to-t ${ind.color} mix-blend-screen opacity-60 group-hover:opacity-90 transition-opacity duration-500`} />

                <div className="relative h-full p-5 flex flex-col justify-between">
                  <div className="w-10 h-10 rounded-xl glass-strong flex items-center justify-center">
                    <Icon size={18} />
                  </div>
                  <div>
                    <h3 className="text-lg font-bold tracking-tight">{ind.name}</h3>
                    <p className="mt-1 text-[11px] font-mono tracking-[0.16em] uppercase text-white/55">
                      Custom growth stack
                    </p>
                  </div>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
